import { v4 as UUIDv4 } from 'uuid';
import clone from 'lodash/clone';
import omit from 'lodash/omit';
import { getImageOssPath, getRemoteImageSize } from '@shakkerai/util-image';
import { getTempState } from '@starflow/app/store';
import { compressRemoteImage, isOverseas } from '@shakkerai/pro-utils';
import { copyOSSImage, MAX_UPLOAD_SIZE } from '@shakkerai/pro-utils';
import { applyDerivativeResults } from '../../derivative';
import { getUnitData } from '../../../helpers/flow';

const getLoraId = (upscaleType) => {
  /**
原图超清对应lora：
国内：2563146
海外：1540094

更多细节 的传参这里，
国内- Version id ：2653284
海外- Version id ：1559805
*/
  // upscaleType 1更多细节  2原图高清
  if (upscaleType === '1') {
    return isOverseas ? 1559805 : 2653284;
  }
  if (upscaleType === '2') {
    return isOverseas ? 1540094 : 2563146;
  }
};
export const upscalePowerParamsHandler = (params) => {
  const baseParams = {
    uuid: UUIDv4(),
    taskQueuePriority: 2,
  };

  baseParams.comfyParams = {
    internalComfyWorkflowType: 3,
    taskQueuePriority: 2,
    hiresUserParam: {
      checkpointId: isOverseas ? 1508012 : 2295774,
      sourceImageId: 'copy/sd-images/2daf83d29cec1eacbaa1545a110179a180612c93bff7d9f1f150e62001a87f5e.png',
      prompt: 'high quality, detailed, photograph , hd, 8k , 4k , sharp, highly detailed',
      scaleFactor: params.scaleFactor,
      steps: 4,
      detailFactor: params.upscaleType === '2' ? 0.05 : params.detailFactor,
      imageWidth: params.width,
      imageHeight: params.height,
      hiresType: parseInt(params.upscaleType),
      loraSetting: {
        loraId: getLoraId(params.upscaleType),
        loraWeight: params.upscaleType === '2' ? 0.9 : 0.8,
      },
    },
  };

  return baseParams;
};

export const upscaleParamsHandler = async ({ params, isTryClacMode = false }) => {
  // 如果是算力计算，走另一处理参数
  if (isTryClacMode) {
    return upscalePowerParamsHandler(params);
  }

  const { sourceElement } = params;

  if (!sourceElement || sourceElement.type !== 'image') return;

  const isSimpleMode = getTempState('globalMode') === 'simple';

  const isGenMode = !isTryClacMode; // 是生成模式
  const referenceImage = sourceElement;

  let tempReferenceImagePath = null;

  if (isGenMode) {
    const remoteSize = await getRemoteImageSize(referenceImage.url);

    if (remoteSize.width > MAX_UPLOAD_SIZE || remoteSize.height > MAX_UPLOAD_SIZE) {
      try {
        const compressUrl = await compressRemoteImage(referenceImage.url, MAX_UPLOAD_SIZE, MAX_UPLOAD_SIZE, true);
        referenceImage = {
          ...referenceImage,
          isTemp: true,
          width: MAX_UPLOAD_SIZE,
          height: MAX_UPLOAD_SIZE,
          url: compressUrl,
        };
      } catch (error) {
        console.log(error);
      }
    }
  }

  if (isGenMode) {
    if (referenceImage.isTemp) {
      tempReferenceImagePath = getImageOssPath(referenceImage.url);
    } else {
      tempReferenceImagePath = await copyOSSImage(
        getImageOssPath(referenceImage.url),
        true,
        isOverseas ? undefined : '3',
      )
        .then((res) => res.url)
        .then(getImageOssPath);
    }
  } else {
    // 预估算力消耗会走到这里，用一个固定的参图片路径就行
    tempReferenceImagePath = 'copy/sd-images/2daf83d29cec1eacbaa1545a110179a180612c93bff7d9f1f150e62001a87f5e.png';
  }

  const baseParams = {
    uuid: UUIDv4(),
    projectData: clone(omit(params, ['sourceElement'])),
    taskQueuePriority: 2,
  };

  baseParams.projectData.mode = 1;
  baseParams.projectData.isSimpleMode = isSimpleMode;
  baseParams.projectData.generateType = 'upscale';

  baseParams.projectData.count = 1;

  // 这俩是实际生图后插入到画布的尺寸，一定要填哦
  baseParams.projectData.renderWidth = Math.round(sourceElement.width * params.scaleFactor);
  baseParams.projectData.renderHeight = Math.round(sourceElement.height * params.scaleFactor);

  baseParams.projectData.sourceElement = {
    id: UUIDv4(),
    url: sourceElement.url,
    sourceId: sourceElement.id,
    innerTaskId: sourceElement.innerTaskId,
    innerImageId: sourceElement.innerImageId,
    width: sourceElement.width,
    height: sourceElement.height,
  };
  baseParams.comfyParams = {
    internalComfyWorkflowType: 3,
    projectData: baseParams.projectData,
    taskQueuePriority: 2,
    hiresUserParam: {
      checkpointId: isOverseas ? 1508012 : 2295774,
      sourceImageId: isGenMode
        ? tempReferenceImagePath
        : // 获取算力用的图片，实际不会使用
          'copy/sd-images/2daf83d29cec1eacbaa1545a110179a180612c93bff7d9f1f150e62001a87f5e.png',
      prompt: 'high quality, detailed, photograph , hd, 8k , 4k , sharp, highly detailed',
      scaleFactor: params.scaleFactor,
      steps: 4,
      detailFactor: params.upscaleType === '2' ? 0.05 : params.detailFactor,
      imageWidth: sourceElement.width,
      imageHeight: sourceElement.height,
      hiresType: parseInt(params.upscaleType),
      loraSetting: {
        loraId: getLoraId(params.upscaleType),
        loraWeight: params.upscaleType === '2' ? 0.9 : 0.8,
      },
    },
  };
  // debugger;
  return baseParams;
};

export const upscaleResultHandler = async (taskData, results) => {
  // 如果要做一些别的操作，可以在这里处理
  // ...
  // debugger;
  // 通用的衍生生图结果处理方式
  return applyDerivativeResults('upscale', taskData, results);
};
